import { render } from "./SvgChannel.vue?vue&type=template&id=47d47cf0"
import script from "./SvgChannel.vue?vue&type=script&lang=js"
export * from "./SvgChannel.vue?vue&type=script&lang=js"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__